import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "container mx-auto p-2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "text-3xl font-bold" }, "タグの編集", -1);
const _hoisted_3 = { class: "text-left" };
const _hoisted_4 = { class: "border-separate border-spacing-y-2" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "px-3" }, "タグの名前"),
        /*#__PURE__*/ _createElementVNode("th", { class: "px-3 text-center" }, "非公開"),
        /*#__PURE__*/ _createElementVNode("th", { class: "px-3 text-center" }, "削除")
    ])
], -1);
const _hoisted_6 = { class: "pl-3" };
const _hoisted_7 = { class: "text-center" };
const _hoisted_8 = ["checked", "onClick"];
const _hoisted_9 = { class: "text-center" };
const _hoisted_10 = ["checked", "onClick"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_12 = { class: "flex" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LinkButton = _resolveComponent("LinkButton");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTags, (tag, k) => {
                        return (_openBlock(), _createElementBlock("tr", {
                            key: k,
                            class: _normalizeClass(tag.isHidden() ? 'bg-gray-300' : '')
                        }, [
                            _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", {
                                        class: "m-px inline-block h-3 w-3 rounded-md",
                                        style: _normalizeStyle({ 'background-color': tag.color })
                                    }, null, 4),
                                    _createTextVNode(" " + _toDisplayString(tag.data.name), 1)
                                ])
                            ]),
                            _createElementVNode("td", _hoisted_7, [
                                _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.updatingTags[tag.id]?.hidden || tag.isHidden(),
                                    onClick: ($event) => (_ctx.addHiddenTag(tag.id, $event))
                                }, null, 8, _hoisted_8)
                            ]),
                            _createElementVNode("td", _hoisted_9, [
                                _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.updatingTags[tag.id]?.deleted,
                                    onClick: ($event) => (_ctx.addDeletedTag(tag.id, $event))
                                }, null, 8, _hoisted_10)
                            ])
                        ], 2));
                    }), 128))
                ])
            ])
        ]),
        _hoisted_11,
        _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.newTagName) = $event)),
                    placeholder: "タグの名前を入力",
                    class: "border-1 m-2 w-full rounded-md p-1 ring-2 focus:ring-rose-600 focus:ring-opacity-20"
                }, null, 512), [
                    [_vModelText, _ctx.newTagName]
                ]),
                _createElementVNode("button", {
                    class: "m-1 h-10 w-72 items-center justify-center rounded-lg bg-green-600 text-base font-bold text-white hover:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-20",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.addTag && _ctx.addTag(...args))),
                    disabled: _ctx.disabledToAddNewTag
                }, [
                    (_ctx.isSameNameTag)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, "同じ名前のタグが存在します"))
                        : (_openBlock(), _createElementBlock("p", _hoisted_15, "タグを追加"))
                ], 8, _hoisted_13)
            ]),
            _createElementVNode("button", {
                class: "m-1 h-10 w-48 items-center justify-center rounded-lg bg-green-600 text-base font-bold text-white hover:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-20",
                onClick: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_ctx.updateTagStatus && _ctx.updateTagStatus(...args))),
                disabled: (_ctx.updatingTags && Object.keys(_ctx.updatingTags).length === 0) ||
                    _ctx.disabledForUpdateButton
            }, [
                (!_ctx.disabledForUpdateButton)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "非公開・削除を更新する"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, "保存中..."))
            ], 8, _hoisted_16),
            _createVNode(_component_LinkButton, {
                class: "mt-3",
                path: "photos",
                name: "一覧へ"
            })
        ])
    ]));
}
